import getArrayInfoFromCache from './getArrayInfoFromCache';

export default getArrayInfoFromCache;
